module.exports = __webpack_public_path__ + "static/black-future-88-blue-40d776eeff4df873f1476a44aa188b73.png";